import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import remove from "@beeldit/core/services/remove";
import { useContext } from "react";
import { ProjectContext } from "../contexts/ProjectContext";

function useRemove() {
  const {elementIdToDelete, setShowDeleteConfirmationModal} = useContext(ProjectContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    remove('projects', elementIdToDelete)
      .then((response: any) => {
        setShowDeleteConfirmationModal(false);
        onSuccess();
      }).catch((error: any) => {
        errorHandler(error)
    })
  }
}

export default useRemove;